import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { payrateGridBO } from './employee.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EmployeepayrateService extends Subject<DataStateChangeEventArgs> {

  constructor(private http: HttpClient) {
    super();
  }

  public executepayrate(state: payrateGridBO): void {
    this.getListPayrate(state).subscribe(x => super.next(x));
  }

  getListPayrate(state?: payrateGridBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/EmployeePayrate/GetEmployeePayrateListFilter", state)
      .pipe(map(
        (response: any) => (<any>{
          result: response['result'],
          count: response['count']
        }))


      )
  }
}
